<script setup>
import LogoComponent from "@/components/top/logoComponent.vue";
import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {useAgeStore, useComStore, useFolderStore, useLanguageStore, useLoginStore} from "@/pinia";
import axios from "@/axios";
import {useToast} from "@/composables/useToast";

const toast = useToast();



// 구글 로그인 삭제로 인한 비활성화 처리
/**
 const clientId = ref(null);
 const imgPath = require('@/assets/googleLogin.png') ;
 const redirectToUrl = ()=>{
 window.location.href = ('https://accounts.google.com/o/oauth2/v2/auth?client_id=' + clientId.value + '&redirect_uri=http://localhost:8090/login/oauth2/code/google&response_type=code&scope=email profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/yt-analytics.readonly https://www.googleapis.com/auth/yt-analytics-monetary.readonly https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtubepartner https://www.googleapis.com/auth/youtubepartner-channel-audit https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.channel-memberships.creator https://www.googleapis.com/auth/youtube.third-party-link.creator https://www.googleapis.com/auth/youtube.download'); //8090/login/oauth2/code/google
 }
 const getData = ()=>{
 axios.get("/api/jsonClientId")
 .then(response => {
 clientId.value = response.data;
 }).catch(error => {
 console.log(error)
 })
 }
 */
const loginStore = useLoginStore();
const languageStore = useLanguageStore();
const useComCode = useComStore();
const folderStore = useFolderStore();
const ageStore = useAgeStore();
const emits = defineEmits(['set_loginStatus']);
const showPassword = ref(false);
const router = useRouter();
const userId = ref('');
const userPassword = ref('');

const baseUrl = process.env.VUE_APP_API_URL;

const idRules = [
  v => !!v && v.trim() !== '' || languageStore.get('enterYourId')
];
const passwordRules = [
  v => !!v && v.trim() !== '' || languageStore.get('enterYourPassword')
];

const loginForm = ref(null);

const fn_login = async ()=>{
  const { valid } = await loginForm.value.validate();
  if(!valid) return;

  const data = {
    "userId" : userId.value.trim(),
    "pwd" : userPassword.value
  }
  axios.post( "/api/login", data, {headers: {'Content-Type': 'application/json'}})
      .then(async success=>{
        loginStore.loginInfo = success.data.userInfo;
        loginStore.jwtToken = success.data.token;

        axios.defaults.headers.common['Authorization'] = `Bearer ${success.data.token}`;

        await Promise.all([
          useComCode.setCommonCode(),
          useComCode.setGroupCodes(),
          useComCode.setUseCommonCodes(),
          folderStore.getFolder(),
          ageStore.setAges(),
        ]);

        router.push("/");
      }).catch(()=>{
        toast.error(languageStore.get('loginFailed'))
  })
}

</script>

<template>
  <v-snackbar v-model="toast.show.value" :color="toast.color.value" :timeout="toast.timeout.value" location="top">
    {{ toast.message.value }}
    <template v-slot:actions>
      <v-btn variant="text" @click="toast.close()">{{ languageStore.get('close') }}</v-btn>
    </template>
  </v-snackbar>
  <div class="loginArea">
    <div class="logoArea">
      <logo-component class="logo"></logo-component>
    </div>
    <v-form ref="loginForm" @submit.prevent="fn_login" validate-on="submit lazy" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
    <div class="idArea">
        <v-text-field
            v-model="userId"
            :label="languageStore.get('userId')"
            :placeholder="languageStore.get('enterYourId')"
            :rules="idRules"
            variant="underlined"
            autofocus
        ></v-text-field>
    </div>
    <div class="passwordArea">
        <v-text-field
            v-model="userPassword"
            :type="showPassword ? 'text' : 'password'"
            :label="languageStore.get('password')"
            :placeholder="languageStore.get('enterYourPassword')"
            :rules="passwordRules"
            variant="underlined"
            @keyup.enter="fn_login"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="showPassword = !showPassword"
        ></v-text-field>
    </div>
    </v-form>
    <div class="loginButtonArea">
      <div class="loginButton" @click="fn_login">{{ languageStore.get('login') }}</div>
      <!-- 구글 로그인
      <div class="gBtn" @click="redirectToUrl" >
        <img :src="imgPath"  :alt="languageStore.get('googleLogin')"/>
        Google Login
      </div>
      -->
    </div>
  </div>

</template>

<style scoped>

.gBtn {
  width: 324px;
  height: 42px;
  cursor: pointer;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f1f1;
}
.loginArea{
  background: white;
  width: 28vw;
  height: 40vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 0px 4px 1px #C7C7C7;
  border-radius: 5px;
  min-width: 400px;
  min-height: 400px;
}
.idArea{
  width: 80%;
  margin-top: 10px;
}
.passwordArea{
  width: 80%;
}

.loginButtonArea{
  margin-top: 15px;
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 30px;
  flex-direction: column;
}
.loginButton{
  color: white;
  cursor: pointer;
  background: #052C65;
  width: 324px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  white-space: nowrap;
}

.logoArea{
  height: 10vh;
  display: flex;
  justify-content: center;
}

</style>